import { DeleteOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Col, Dropdown, Flex, Modal, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import TableAntd from "components/elements/Table";
import { FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

const SettingProjectAddRoleModal = ({
    isRoleModalOpen,
    onRoleModalCancel = () => { },
    employeeOptions = [],
    roleOption = [],
    onAddEmployee = () => { },
    tableDataSourceCreate = [],
    onSubmitMappingEmployeeRole = () => { },
    roleAction = null,
    onPageEmployeeByRoleChange = () => { },
    pagination = {},
    onSearchEmployeeByRole = () => { },
    onRemoveEmployeeRoleCreate = () => { },
}) => {
    const { t, i18n } = useTranslation();
    const [form] = useForm();
    const modalTitle = roleAction ? (roleAction == "EDIT" ? t("setting_project.label.edit_role") : t("setting_project.label.view_role")) : t("setting_project.label.add_role")
    const [searchTxt, setSearchTxt] = useState("")

    const onFilterEmployeeBySearch = useMemo(() => {
        if (searchTxt) {
            return tableDataSourceCreate?.filter(o => (o?.fullName?.includes(searchTxt) || o?.fullNameEn?.includes(searchTxt) || o?.employeeNo?.includes(searchTxt)))
        }
        return tableDataSourceCreate;

    }, [tableDataSourceCreate, searchTxt])


    const modalSubmitSaveEmployee = useCallback(() => {
        return Modal.confirm({
            title: t("dialog.confirmation.header"),
            content: i18n.language === 'en' ? "Are you sure you want to add employee to this role?" : "ยืนยันการเพิ่มพนักงานเข้าในบทบาทนี้หรือไม่",
            onOk() {
                onSubmitMappingEmployeeRole(form.getFieldsValue(true), form);
                setSearchTxt("")
                form.resetFields();
            },
            okText: t("common.confirm"),
            cancelText: t("common.cancel"),
        });
    }, [onSubmitMappingEmployeeRole, form])

    const columns = [
        {
            title: <div className="text-table" style={{ textAlign: "center" }}>{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            render: (_, record, idx) => {
                return <span
                    style={{
                        color: "#42526D",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "50%",
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                        padding: "8px",
                        minWidth: "30px",
                        height: "30px",
                    }}
                >
                    {/* {idx + 1} */}
                    {((pagination?.current ?? 1) - 1) * (pagination?.pageSize ?? 10) + idx + 1}
                </span>
            },
            width: 90,
            align: "center"
        },
        {
            title: <div className="text-table">{t('employee.label.employee_no')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "employeeFullName",
            key: "employeeFullName",
            render: (_, record) => {
                return i18n.language === 'en' ? record?.fullNameEn : record?.fullName
            }
        },
        {
            title: "",
            key: "action",
            align: "center",
            width: 90,
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    key: "1",
                                    onClick: () => onRemoveEmployeeRoleCreate(record),
                                    label: `${t("action.delete")}`,
                                    icon: (
                                        <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        }
    ]




    return (
        <Modal
            open={isRoleModalOpen}
            closable={false}
            maskClosable={false}
            footer={false}
            width={620}
        >
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Flex vertical>
                    <h3>{modalTitle}</h3>
                    <span style={{ color: "#667085" }}>{t("setting_project.label.detail_2")}</span>
                </Flex>

                <FormAntd
                    form={form}
                    onFinish={modalSubmitSaveEmployee}
                >
                    <FormItem shouldUpdate>
                        {({ getFieldsValue, getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                    <Col>
                                        <FormSelect
                                            name="stpTimeSheetRoleId"
                                            label={t("setting_timesheet.label.roleName")}
                                            placeholder={t("common.pleaseSelect")}
                                            size="large"
                                            options={roleOption}
                                            required
                                        />
                                    </Col>

                                    <Row>
                                        <Col span={19}>
                                            <Flex vertical>
                                                <h3>{t("setting_project.label.add_member")}</h3>
                                                <FormSelect
                                                    name="employeeList"
                                                    placeholder={t("common.pleaseSelect")}
                                                    size="large"
                                                    mode="multiple"
                                                    options={employeeOptions}
                                                />
                                            </Flex>
                                        </Col>
                                        <Col span={5} style={{ alignContent: "end", textAlignLast: "end" }}>
                                            <Button
                                                onClick={() => {
                                                    onAddEmployee(getFieldValue("employeeList"))
                                                    setFieldValue("employeeList", [])
                                                }}
                                                disabled={getFieldValue("employeeList") == null || getFieldValue("employeeList")?.length == 0}
                                                size="large"
                                                type="primary"
                                                style={{ borderRadius: "8px", backgroundColor: (getFieldValue("employeeList") == null || getFieldValue("employeeList")?.length == 0) ? "" : "var(--button-color)" }}
                                            >
                                                {t("setting_project.label.add_member")}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row style={{ gap: "6px" }}>
                                        <Col span={19}>
                                            <FormInput
                                                name="searchTxt"
                                                label={t("common.search_name_empId")}
                                                size="large"
                                                allowClear={true}
                                            />
                                        </Col>
                                        <Col span={4} style={{ alignContent: "end" }}>
                                            <Button
                                                type="default"
                                                style={{ borderRadius: "8px", height: "40px", color: "#565656", fontWeight: "bold" }}
                                                onClick={() => setSearchTxt(getFieldValue("searchTxt"))
                                                }
                                            >
                                                {t("common.search")}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <TableAntd
                                        columns={columns}
                                        dataSource={onFilterEmployeeBySearch}
                                        rowKey={(record) => record?.employeeId}
                                        noPage={true}
                                        onChange={onPageEmployeeByRoleChange}
                                        pagination={{
                                            ...pagination,
                                            showTotal: (total, range) =>
                                                t("paginate.description")
                                                    .replace("{min}", range[0])
                                                    .replace("{max}", range[1])
                                                    .replace("{total}", total),
                                        }}
                                    />
                                    <Flex gap={8} justify="end">
                                        <Button
                                            type="default"
                                            style={{ borderRadius: "8px", height: "40px", color: "#565656", fontWeight: "bold" }}
                                            onClick={() => {
                                                onRoleModalCancel()
                                                setSearchTxt("")
                                                form.resetFields()
                                            }}
                                        >
                                            {t("common.cancel")}
                                        </Button>

                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color", fontWeight: "bold" }}
                                        >
                                            {t("common.save")}
                                        </Button>
                                    </Flex>
                                </Space>
                            )
                        }}

                    </FormItem>

                </FormAntd>




            </Space>
        </Modal >
    )
}

export default SettingProjectAddRoleModal;